/**
 * @readonly
 * @typedef {Object} VehicleMakeModel
 * @property {string} MAKE_NAME - The make name
 */
export const VehicleMakeModel = {
    MAKE_NAME: 'makeName'
}
